import { RouteLocationRaw } from "vue-router"

import { Retrospective } from "@/models/Retrospective"
import { Actions, Getters, store } from "@/store"

export default async (
  to,
  from,
  next: (arg?: RouteLocationRaw) => void
): Promise<void | boolean> => {
  const sprintId = store.getters[Getters.GET_SESSION_SPRINT_ID]
  const retrospectiveIncludingMetadata = await store.dispatch(
    Actions.GET_RETROSPECTIVE_BY_SPRINT_ID,
    sprintId
  )

  if (!retrospectiveIncludingMetadata?.retrospectiveExists) {
    return next({
      name: "Error",
      query: {
        code: 404
      }
    })
  }

  const retrospective: Retrospective = store.getters[Getters.GET_RETROSPECTIVE]

  if (retrospective.isCompleted || retrospective.isRevealed) {
    return next({
      name: "retrospective",
      params: to.params
    })
  }

  next()
}
